import clsx from "clsx";
import { useState } from "react";

type Props = {
    conversation: any;
}

export const MessageGeneralInfo = ({ conversation }: Props) => {
    const [open, setOpen] = useState(true);

    const formatDateStarted = (dateStr?: string) => {
        if (!dateStr) return "N/A";
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return "N/A";
        
        const day = date.getDate();
        let suffix = "th";
        if (day === 1 || day === 21 || day === 31) suffix = "st";
        else if (day === 2 || day === 22) suffix = "nd";
        else if (day === 3 || day === 23) suffix = "rd";
        
        const month = date.toLocaleString('en-US', { month: 'long' });
        const year = date.getFullYear();
        
        return `${month} ${day}${suffix}, ${year}`;
    };

    return (
        <div className={clsx("messages-info-card", { "collapsed": !open })}>
            <div className="d-flex flex-row justify-content-between w-100" style={{ cursor: 'pointer' }} onClick={() => setOpen(prev => !prev)}>
                <span className="title">General Information</span>
                <div className="collapse-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                        <path d="M12.5194 9.70701C12.4759 9.75059 12.4242 9.78517 12.3673 9.80876C12.3104 9.83235 12.2494 9.84449 12.1878 9.84449C12.1262 9.84449 12.0652 9.83235 12.0083 9.80876C11.9514 9.78517 11.8997 9.75059 11.8561 9.70701L7.50026 5.35056L3.1444 9.70701C3.05644 9.79497 2.93715 9.84438 2.81276 9.84438C2.68837 9.84438 2.56908 9.79497 2.48112 9.70701C2.39316 9.61905 2.34375 9.49976 2.34375 9.37537C2.34375 9.25098 2.39316 9.13168 2.48112 9.04373L7.16862 4.35623C7.21215 4.31265 7.26385 4.27807 7.32076 4.25448C7.37766 4.23089 7.43866 4.21875 7.50026 4.21875C7.56186 4.21875 7.62286 4.23089 7.67976 4.25448C7.73667 4.27807 7.78837 4.31265 7.8319 4.35623L12.5194 9.04373C12.563 9.08726 12.5976 9.13896 12.6211 9.19587C12.6447 9.25277 12.6569 9.31377 12.6569 9.37537C12.6569 9.43697 12.6447 9.49797 12.6211 9.55487C12.5976 9.61178 12.563 9.66348 12.5194 9.70701Z" fill="#151515"/>
                    </svg>
                </div>
            </div>
            {open && (
                <>
                    <div className="d-flex flex-column align-items-start">
                        <span className="text-muted">Type of Introduction</span>
                        <span className="text-bold">{conversation.introductionTypeTitle || conversation.introduction_type_title || "General introduction"}</span>
                    </div>
 
                    <div className="d-flex flex-column align-items-start" style={{gap: '10px', width: '100%'}}>
                        <div className="d-flex flex-column align-items-start w-100">
                            <span className="text-muted">Message</span>
                            <p className="text-body m-0" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontSize: '12px' }}>
                                {conversation.introductionMessage || conversation.introduction_message || "No initial message."}
                            </p>
                        </div>
                    </div>
 
                    <div className="d-flex flex-column align-items-start justify-content-center" style={{ gap: '5px' }}>
                        <span className="text-subtitle">Date Started</span>
                        <div className="d-flex flex-row align-items-center" style={{ gap: '5px' }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M6.66602 1.66406V4.16406" stroke="#808080" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M13.334 1.66406V4.16406" stroke="#151515" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M2.91602 7.57812H17.0827" stroke="#151515" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M17.5 7.08073V14.1641C17.5 16.6641 16.25 18.3307 13.3333 18.3307H6.66667C3.75 18.3307 2.5 16.6641 2.5 14.1641V7.08073C2.5 4.58073 3.75 2.91406 6.66667 2.91406H13.3333C16.25 2.91406 17.5 4.58073 17.5 7.08073Z" stroke="#151515" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M13.0781 11.4141H13.0856" stroke="#151515" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M13.0781 13.9141H13.0856" stroke="#151515" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M9.99609 11.4141H10.0036" stroke="#151515" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M9.99609 13.9141H10.0036" stroke="#151515" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M6.91211 11.4141H6.91959" stroke="#151515" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M6.91211 13.9141H6.91959" stroke="#151515" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span className="text-date-bold">
                                {formatDateStarted(conversation.introductionCreatedAt || conversation.introduction_created_at)}
                            </span>
                        </div>
                    </div>                
                </>
            )}
        </div>
    )
}